<template>
  <div class="query-xd-id w-full">
      <div class="mt-5">建议在游戏内选用以下方法，查询心动ID。</div>
      <div class="mt-10">方法一：可通过【用户中心】进入【账号安全】页面查看心动ID，以《香肠派对》为例：</div>
      <img class="mt-5" src="https://res.xdcdn.net/xd-logout/assets/imgs/step1/step1-pic1.png" alt="">
      <img class="mt-5" src="https://res.xdcdn.net/xd-logout/assets/imgs/step1/step1-pic2.png" alt="">
      <div class="mt-5">方法二：进入【用户中心】查看心动ID，以《人类跌落梦境》为例：</div>
      <img class="mt-5 mb-5" src="https://res.xdcdn.net/xd-logout/assets/imgs/step1/step1-pic3.png" alt="">
  </div>
</template>

<script>

export default {

}
</script>

<style lang="less" scoped>
div{
    -webkit-text-size-adjust: 100%;
}
.query-id-content{
    height: 100%;
    overflow-y: scroll;
}
.query-xd-id{
    width: 100%;
    // overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    /* 正文 */
    color: #5C5C5C;
    div{
        width: 95%;
    }
    img{
        width: 95%;
    }
}
</style>
